import React from "react"
import AlarmImg from "../../../../../assets/avia/sidebar/alarm.png"
import { useTranslation } from "react-i18next"

const PriceAlert = ({ priceAlert, setPriceAlert }) => {
  const { t } = useTranslation()

  return (
    <div className="mb-[11px]  pb-4 relative">
      <div className="flex items-center justify-between">
        <span className="text-dark-gray text-base font-normal">
          {t("admin.price_notification")}
        </span>
        <label className="relative inline-block w-12 h-6 cursor-pointer">
          <input
            type="checkbox"
            checked={priceAlert}
            onChange={(e) => setPriceAlert(e.target.checked)}
            className="sr-only peer"
          />
          <div className="w-full h-full bg-gray-400 rounded-full peer-checked:bg-gray-400 transition-all duration-300"></div>
          <div
            className={`absolute top-1/2 -translate-y-1/2 left-0 w-7 h-7 bg-white rounded-full shadow-md transition-transform duration-300 flex items-center justify-center border border-gray-200 ${
              priceAlert ? "translate-x-7" : ""
            }`}
          >
            <img src={AlarmImg} alt="alarm icon" className="w-4 h-4" />
          </div>
        </label>
      </div>
      <div className="absolute top-8 left-0 right-0 border-b  border-light-gray/25"></div>
    </div>
  )
}

export default PriceAlert
